import type { CustomFile } from '../types';

import getRelativePathData from './getRelativePathData';

// ----------------------------------------------------------------------------

export type TypeGroupedFilesResult = Record<string, { files: CustomFile[]; totalSize: number }>;

// ----------------------------------------------------------------------------

function groupFilesByRelativePath(files: CustomFile[]): TypeGroupedFilesResult {
    const groupedFiles: TypeGroupedFilesResult = {};

    //
    for (const file of files) {
        const pathData = getRelativePathData(file);

        if (pathData == null) {
            continue;
        }
        const dirPath = pathData.dirPath ?? '/';

        if (!groupedFiles[dirPath]) {
            groupedFiles[dirPath] = { files: [], totalSize: 0 };
        }

        groupedFiles[dirPath].files.push(file);
        groupedFiles[dirPath].totalSize += file.size;
    }

    //
    return groupedFiles;
}

// ----------------------------------------------------------------------------

export default groupFilesByRelativePath;
